import { createMmWsAction } from '@skynet/data-ws-mm';
import { LoanAmountsCommands } from './types';

export interface AddLoanAmountPayload {
  loanID: string;
  amount: number;
  type: number;
  currency: string;
  price?: number;
  description?: string;
  /** ISO date string — transaction date (loan amounts) / unlock date (OTC trenches). */
  transactionDate?: string;
}

export const addLoanAmount = createMmWsAction<AddLoanAmountPayload, AddLoanAmountPayload>(
  'loans/addLoanAmount',
  (data) => ({
    command: LoanAmountsCommands.AddLoanAmount,
    ...data,
  }),
);

export interface UpdateLoanAmountPayload extends AddLoanAmountPayload {
  id: number;
}

export const updateLoanAmount = createMmWsAction<
  UpdateLoanAmountPayload,
  Omit<UpdateLoanAmountPayload, 'id'> & { loanAmountID: number }
>('loans/updateLoanAmount', ({ id, ...data }) => ({
  command: LoanAmountsCommands.UpdateLoanAmount,
  ...data,
  loanAmountID: id,
}));

export interface DeleteLoanAmountPayload {
  loanID: string;
  id: number;
}

export const deleteLoanAmount = createMmWsAction<
  DeleteLoanAmountPayload,
  Omit<DeleteLoanAmountPayload, 'id'> & { loanAmountID: number }
>('loans/deleteLoanAmount', ({ id, ...data }) => ({
  command: LoanAmountsCommands.DeleteLoanAmount,
  ...data,
  loanAmountID: id,
}));
